import * as React from 'react';
import Button from '../../../components/Button';

interface InviteAllCandidatesFormProps {
    onInviteAllCandidates: () => void;
}

interface InviteAllCandidatesFormState {
    showInvitationSentNotification: boolean;
}

class InviteAllCandidatesForm extends React.Component<InviteAllCandidatesFormProps, InviteAllCandidatesFormState> {
    constructor(props: InviteAllCandidatesFormProps) {
        super(props);
    }

    public render() {
        return (
            <div>
                <p>Send all candidates an e-mail with an invitation to record their V-Sponeses to the questions.</p>
                <Button onClick={this.props.onInviteAllCandidates}>send e-mails to all candidates</Button>
            </div>
        );
    }
}

export default InviteAllCandidatesForm;



// WEBPACK FOOTER //
// ./src/scenes/administrator/components/InviteAllCandidatesForm.tsx